import Price from 'components/commerce/Price';
import './PaperworkOfferPrice.css';

// Presentation only: the existing saved-price loader supplies both amounts.
// The cart still uses its existing authoritative effective price/deposit logic.
export default function PaperworkOfferPrice({ offer, minor, layout }) {
  const current = offer?.priceMinor ?? minor;
  const onSale = offer?.onSale === true && Number.isSafeInteger(current)
    && Number.isSafeInteger(offer.originalMinor) && offer.originalMinor > current;
  if (layout === 'card') return <span className="pw-offer-price pw-offer-price--card">
    <span className="pw-offer-base">Price:</span>
    <span className="pw-offer-current">{onSale && <span className="sr-only">Sale price </span>}<Price minor={current} /></span>
    {onSale && <s className="pw-offer-original"><span className="sr-only">Original price </span><Price minor={offer.originalMinor} /></s>}
  </span>;
  return <span className="pw-offer-price">
    {onSale && <>
      <span className="pw-offer-label">Sale</span>
      <s><span className="sr-only">Original price </span><Price minor={offer.originalMinor} /></s>
    </>}
    <span className="pw-offer-current">{onSale && <span className="sr-only">Sale price </span>}<Price minor={current} /></span>
  </span>;
}
